import { CircularProgress } from "@material-ui/core";
import { useRef, useCallback } from "react";

type InfiniteScrollProps = {
  fetchMoreData: () => void;
  hasMore: boolean;
  loading: boolean;
  children: React.ReactNode;
};

const InfiniteScroll = ({
  fetchMoreData,
  hasMore,
  loading,
  children,
}: InfiniteScrollProps) => {
  const observer = useRef<IntersectionObserver | null>(null);
  const lastElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          fetchMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore, fetchMoreData]
  );

  return (
    <div>
      {children}
      <div ref={lastElementRef} style={{ height: "20px" }} />
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "20px 0",
          }}
        >
          <CircularProgress
            color="inherit"
            size={25}
            disableShrink
            style={{ marginRight: 8 }}
          />
        </div>
      )}
    </div>
  );
};

export default InfiniteScroll;
